import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { compose } from 'redux';

import GridItem from '../../components/GridItem/GridItem';
import Img from '../../components/ImageLoader/ImageLoader';
import { AriaRoles } from '../../constants/AccessibilityConstants';
import QA from '../../constants/QATags';
import { StationMessages } from '../../constants/StationConstants';
import { getInDomain } from '../../domains/externalUtils';
import { getArt } from '../../lib/ArtUtils';
import { AppContextIntegrationData } from '../../lib/Context';
import { getBrowseGenreCategoryPath } from '../../lib/RouteUtils';

import './GenreCategoryGridItem.scss';

const intlMessages = defineMessages({
  numStations: {
    id: 'GenreCategoryGridItem.numStations',
    defaultMessage: `{stationCount, plural,
      one {1 Station}
      other {# Stations}
    }`,
  },
});

class GenreCategoryGridItem extends React.Component {
  static propTypes = {
    genreCategoryToken: PropTypes.string.isRequired,
    genreCategoryName: PropTypes.string.isRequired,
    genreCategoryUrl: PropTypes.string.isRequired,
    stationCount: PropTypes.number.isRequired,
    imageUrl: PropTypes.string,
    listenerCount: PropTypes.number,
    showListenerCount: PropTypes.bool,
  };

  renderHoverOverlay = () => {
    return (
      <Link to={this.props.genreCategoryUrl} data-qa={QA.HVSB}>
        <div className='GenreCategoryGridItem_hoverOverlay'>
          <div className='GenreCategoryGridItem_hoverOverlayText'>
            <FormattedMessage {...StationMessages.viewStations} />
          </div>
        </div>
      </Link>
    );
  };

  getIntegrationData = () => {
    return {
      genreCategoryToken: this.props.genreCategoryToken,
    };
  };

  render() {
    const { genreCategoryUrl, imageUrl, genreCategoryName, stationCount, listenerCount } =
      this.props;
    let secondLine;
    if (this.props.showListenerCount) {
      secondLine = getInDomain('catalog.utils.displayListenerCount')(listenerCount);
    } else {
      secondLine = <FormattedMessage {...intlMessages.numStations} values={{ stationCount }} />;
    }
    const props = {
      hoverOverlay: this.renderHoverOverlay(),
      art: (
        <Link to={genreCategoryUrl}>
          <Img src={imageUrl} alt={genreCategoryName} role={AriaRoles.BUTTON} data-qa={QA.GCTI} />{' '}
        </Link>
      ),
      firstLine: <Link to={genreCategoryUrl}>{genreCategoryName}</Link>,
      firstLineQaTag: QA.GCNL,
      secondLineQaTag: QA.GSC,
      secondLine,
    };

    return (
      <AppContextIntegrationData data={this.getIntegrationData}>
        <GridItem {...props} />;
      </AppContextIntegrationData>
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const genreCategoryToken = ownProps.genreCategoryToken;
  const genreCategory = state.entities.get('categories').get(genreCategoryToken);

  return {
    genreCategoryName: genreCategory && genreCategory.get('name'),
    genreCategoryUrl: getBrowseGenreCategoryPath(genreCategoryToken),
    stationCount: genreCategory && genreCategory.get('stationCount'),
    imageUrl: getArt(genreCategory, 500),
    listenerCount: genreCategory && genreCategory.get('listenerCount'),
  };
}

const enhance = compose(connect(mapStateToProps));

export default enhance(GenreCategoryGridItem);
